export default "__VITE_ASSET__OklwhYv___"